export default __webpack_public_path__ + "static/media/INd.d2e27a47.jpg";